'use strict';

var FlightBidPriceGraphFilterFactory = function FlightBidPriceGraphFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightLevelFilterFactory', 'FlightCabinFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FlightBidPriceGraphFilter() {
    DemandFilter.call(this, ['cabin', 'cabin-deep'], 'bid-price-graph');
    this.registerFilters(injectedFilters);
  }
  FlightBidPriceGraphFilter.prototype = Object.create(DemandFilter.prototype);
  FlightBidPriceGraphFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  return FlightBidPriceGraphFilter;
};
FlightBidPriceGraphFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FlightBidPriceGraphFilterFactory;